import {persistState} from '../../../services/util/persistState'

const extractResourcesByResourceType = (resourceArray, typeName) => {
    // each resource permission comes as a combination of name:type i.e.) Telus:business
    const resourceNameArrayWithTypeName = resourceArray.filter(resource => resource.includes(typeName))
    const resourceNameArray = resourceNameArrayWithTypeName.map(resource => resource.split(":")[0])

    if (resourceNameArray.length === 0) return ['']
    return resourceNameArray
}

const lowerCaseItems = (array) => {
   return array.map( item =>　item.toLowerCase())
}

export const populatePermissions = (loginResponse) => {
    let grantedResourcesPermissionArray = loginResponse.data?.resource_names?.split(",") ?? []

    let grantedBusinessPermissionArray = extractResourcesByResourceType(grantedResourcesPermissionArray, "business")
    let grantedTerritoryPermissionArray = extractResourcesByResourceType(grantedResourcesPermissionArray, "territory")

    let features = {location: null, people: null, service: null, account: null }
    const crud = loginResponse.data?.feature_names?.split(",") ?? []
    const crudAllLowerCase = lowerCaseItems(crud)
    console.log(loginResponse.data)

    grantedResourcesPermissionArray.forEach((feature)=>{
        switch(feature){
            case "View Location Information":
                if(!features.location) features = {...features, location: 'View'}
                break
            case "Update Location Information":
                features = {...features, location: 'Update'}
                break
            case "View People Information":
                if(!features.people) features = {...features, people: 'View'}
                break
            case "Update People Information":
                features = {...features, people: 'Update'}
                break
            case "View Service Information":
                if(!features.service) features = {...features, service: 'View'}
                break
            case "Update Service Information":
                features = {...features, service: 'Update'}
                break
            case "View Account Information":
                if(!features.account) features = {...features, account: 'View'}
                break
            case "Update Account Information":
                features = {...features, account: 'Update'}
                break
            default:
        }
    })

    const permissions = {
        features,
        resources: {
            businessResource: grantedBusinessPermissionArray,
            territoryResource: grantedTerritoryPermissionArray
        },
        crud: crudAllLowerCase
    }

    persistState("permissions", permissions)
}